import {observable, action} from 'mobx';

class SensorStore{
    // 传感器数据
    @observable.shallow sensors = [];

    @action setSensors(sensors) {
        this.sensors = sensors;
    }

    @observable.shallow deviceUser = [];

    @action setDeviceUser(deviceUser) {
        this.deviceUser = deviceUser;
    }

    @observable.shallow deviceSn = [];

    @action setDeviceSn(deviceSn) {
        this.deviceSn = deviceSn;
    }

    @observable.shallow curveData = [];

    @action setCurveData(curveData) {
        this.curveData = curveData;
    }
}

export default new SensorStore();
